const styles = () => ({
  root: {
    flex: '1 1 auto',
    overflow: 'auto',
    display: 'flex',
    minHeight: 0,
  },

  listItem: {
    height: 65,
    display: 'flex',
    flexDirection: 'row',
    boxShadow: '0 1px 0 #EDEEEF',
  },

  muiList: {
    padding: 0,
    flex: '1 1 auto',
  },

  muiListItem: {
    flex: '1 1 auto',
  },

  primary: {
    fontSize: '20px',
    color: '#5786D7',
    letterSpacing: '0',
    flex: 'none',
    minWidth: 240,
  },

  secondary: {
    opacity: 0.5,
    fontSize: 15,
    color: '#A9B0B8',
    margin: '0 15px',
  },

  spacer: {
    flex: '1 1 auto',
  },

  actions: {
    color: '#A9B0B8',
    fontSize: 15,
    margin: '0 0 0 15px',
  },

  loading: {
    flex: '1 1 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 200,
  },

  empty: {
    flex: '1 1 auto',
    fontSize: 15,
    color: '#A9B0B8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 100,
  },
});

export default styles;
